import { FormikSubmitButton } from 'formik-ui';
import React from 'react';
import AddressForm from '~/components/Address/AddressForm';
import { ModalProps } from '~/components/Modal/ModalsGroup';
import NewModalBody from '~/components/NewModal/NewModalBody';
import NewModalCloseActionButton from '~/components/NewModal/NewModalCloseActionButton';

const AddressModal: React.FC<ModalProps<'address'>> = ({
  defaultFlags,
  editAddress,
  neverShowCheckboxes,
  onRequestClose,
  onSuccessfulSubmit,
}) => (
  <NewModalBody title={editAddress ? 'Edit Address' : 'Create New Address'}>
    <AddressForm
      actions={
        <div className="grid grid-cols-2 gap-4">
          <NewModalCloseActionButton>Back</NewModalCloseActionButton>

          <FormikSubmitButton color="turf-green">
            {editAddress ? 'Update Address' : 'Create Address'}
          </FormikSubmitButton>
        </div>
      }
      editAddress={editAddress}
      defaultFlags={defaultFlags}
      neverShowCheckboxes={neverShowCheckboxes}
      onSuccessfulSubmit={address => {
        onSuccessfulSubmit?.(address);
        onRequestClose();
      }}
    />
  </NewModalBody>
);

export default AddressModal;
